import { partial } from 'underscore';
import { putFormJSON } from 'bv-fetch';

export default partial(putFormJSON, '/preferences');
